import { EnumObject } from '../../shared/EnumObject';

export class ChangedItem {
  public id?: string;
  public historyId?: string;
  public itemId?: string;
  public itemType?: EnumObject;
  public properties?: EnumObject;
  public oldValue?: string;
  public newValue?: string;

  constructor(init?: Partial<ChangedItem>) {
    Object.assign(this, init);
  }
}
